import {BrowserRouter} from 'react-router-dom'
import Navigation from './navigation/Navigation'
import {LocalizationProvider} from './providers/LocalizationProvider'
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';

const App = () => {
    return (
        <LocalizationProvider>
            <GoogleReCaptchaProvider reCaptchaKey="6LeVIPsrAAAAAOg_F5twzSrm9A8xIC0LApPWmxg-">
                <BrowserRouter>
                    <Navigation/>
                </BrowserRouter>
            </GoogleReCaptchaProvider>
        </LocalizationProvider>
    )
}

export default App